import React, { FC } from 'react';

import { useHeader } from '../components/common/navigation/hooks/header-service';
import Map from '../components/universe/map';

const UniversePage: FC = () => {
  useHeader('Вселенная');

  return (
    <>
      <Map />
    </>
  );
};

export default UniversePage;
